import React, { useState, useEffect, useContext } from 'react';
import AdminContext from '../../../StateContext/Application';
// import { True32 } from '../../../../public/LoginImages/importimages'
import { apiurl } from '../../../../../path';
import { Link } from 'react-router-dom';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';


const FinancialGR = () => {
       const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext);
    const { GetFinanceGRListForApprove, FinanceGRApproveOperation, CreateToken, GetBudgetHeadInfo ,Usermenu } = context; // Ensure ApproveBills is defined in your context

    const [selectedGR, setSelectedGR] = useState(null);
    const [showSpecific, setShowSpecific] = useState(0);
    const [resultFinacialdata, setResultFinancialData] = useState([]);
    const [bills, setBills] = useState([]);
    const [selectedBills, setSelectedBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10; // Show 4 bills per page
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBills, setFilteredBills] = useState([]);

    const [rejectPanelhide, setRejectpanelhide] = useState(1);
    const [remark, setRemark] = useState("");

    const [hide, sethide] = useState(true)
    const [Etoken, SetEtoken] = useState(false)
    const [GenerateToken, SetGenerateToken] = useState(true)
    const [GenerateRejectToken, SetGenerateRejectToken] = useState(true)
    const[RoleID,setroleID]=useState(null)
    async function GenerateTokenFor(e) {
        e.preventDefault();
        let data = await CreateToken('GR Approval');
        document.getElementById('tokencopys').innerText = data
        SetEtoken(data)
        sethide(false)
    }

    // Filter logic
    // const filteredBills = filter ? bills.filter((bill) => bill.TypeOfAmount === filter) : bills;
    const getbills = async () => {
        let data = await GetFinanceGRListForApprove();
        console.log("data", data);

        setBills(data);
        setFilteredBills(data);
    };

    useEffect(() => {
        getbills();
        getmenu();
    }, []);

            const getmenu = async () => {
        try {
            const data = await Usermenu();
            if (!data || typeof data !== "object") {
            console.error("Invalid data:", data);
            return;
            }
            const roleID = data?.Data?.RoleID;
            setroleID(roleID)
        console.log("sffdsf",data?.Data)
        } catch (error) {
            console.error("Error in AdminNavbar getmenu:", error);
        }
        };
    // Pagination logic
    const totalPages = Math.ceil(filteredBills ? filteredBills.length / billsPerPage : bills.length / billsPerPage);

    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;

//    const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
// .sort((a, b) => new Date(b.Date) - new Date(a.Date))
//         : [];
        const sortedBills= filteredBills;
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
    // const currentBills = filteredBills ? filteredBills.slice(indexOfFirstBill, indexOfLastBill) : bills.slice(indexOfFirstBill, indexOfLastBill);

    // Handle individual checkbox selection
    const handleCheckboxChange = (id) => {
        setSelectedBills((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((billId) => billId !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };

    // Handle "Select All" checkbox
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedBills(currentBills.map((bill) => bill.ID));
        } else {
            setSelectedBills([]);
        }
    };

    const approveorrejectSelected = async (condition) => {
        if (selectedBills.length === 0) {
            alert('No Financial GR selected !!!');
            return;
        }
        console.log(selectedBills);
             if(condition=="Rejected"||condition=="SendBack"){
           const cleanRemark = remark.trim().replace(/\s+/g, " ");

    // ❌ If remark is empty after trimming
    if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
    }}
        setLoading(true); // Start loader
        let shouldStart = window.confirm("Are you sure ??");

        if (shouldStart) {
            try {
                let response = await FinanceGRApproveOperation(selectedBills, condition, remark, Etoken); // Call backend function
                if (response.message) {
                    alert(response.message);
                    window.location.reload()
                    setRemark('');
                    setRejectpanelhide(0);
                    getbills(); // Refresh the list after approval
                }
                if (response.error) {
                    alert(response.error)
                    window.location.reload()
                    getbills(); // Refresh the list after approval
                }
            } catch (error) {
                console.error('Error Approving or Rejecting  bills:', error);
                alert('An error occurred while approving or rejecting bills.');
            }
        }
        else {
            alert(`Gr ${condition} Operation Cancelled !!!`);
            setRemark('');
            setRejectpanelhide(0);
            window.location.reload();
            getbills();
        }
        setLoading(false); // Stop loader
    };

    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = bills.filter(bill =>
            Object.values(bill).some((bill) =>
                (bill || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, bills]);

    const showSpecificFinancialGRData = async (Fid) => {
        try {
            let res = await GetBudgetHeadInfo(Fid, "GetSpecificFinanceFromReleaseTable");
            setResultFinancialData(res);
            console.log("result ---------- ", res);
            setShowSpecific(1);
        }
        catch (err) {
            console.log(err);
        }
    }



    // return (


    //     <>

    //         <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-12 px-3 m-auto">

    //                 {loading && (
    //                     <div
    //                         style={{
    //                             position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
    //                             display: 'flex', justifyContent: 'center', alignItems: 'center'
    //                         }}>
    //                         <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
    //                         <style>
    //                             {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
    //                         </style>
    //                     </div>
    //                 )}

    //                 <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //                     <h5 className='my-auto fw-bold'>
    //                         <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                         <span className='my-auto'>Limit Allocation Approval</span>
    //                     </h5>

    //                     {
    //                         showSpecific === 0 &&
    //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                             <img
    //                                 src="/Search32.png"
    //                                 alt="Search Icon"
    //                                 style={{
    //                                     position: "absolute",
    //                                     top: "50%",
    //                                     left: "10px",
    //                                     transform: "translateY(-50%)",
    //                                     width: "16px",
    //                                     height: "16px",
    //                                     opacity: 0.6
    //                                 }}
    //                             />
    //                             <input
    //                                 type="text"
    //                                 placeholder="Search Here"
    //                                 onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                     border: "1px solid #ccc",
    //                                     borderRadius: "8px",
    //                                     backgroundColor: "#f1f6fc",
    //                                     fontSize: "14px",
    //                                     color: "#333",
    //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                     outline: "none"
    //                                 }}
    //                             />
    //                         </div>

    //                     }
    //                 </div>


    //                 <div className='col-12' >
    //                     {
    //                         showSpecific === 0 &&
    //                         <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
    //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
    //                                  <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                     <thead >
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>

    //                                             <th style={{ width: "4%", textAlign: "center" }}>
    //                                                 <input
    //                                                     type="checkbox"
    //                                                     onChange={handleSelectAll}
    //                                                     checked={selectedBills.length === currentBills.length}
    //                                                     className='my-auto'
    //                                                     style={{ height: '1rem', width: '1rem' }}
    //                                                 />
    //                                             </th>
    //                                             {/* <th>View Info</th> */}
    //                                             <th style={{ width: "9%" }}>Sr. No.</th>
    //                                             {/* <th style={{ width: "9%" }}>Financial Release UID</th> */}
    //                                             {/* <th style={{ width: "9%" }}>Head Code</th>
    //                                             <th style={{ width: "9%" }}>Proposal ID</th>
    //                                             <th style={{ width: "8%" }}>Proposal Year</th>
    //                                             <th style={{ width: "8%" }}>Zilla Parishad</th>
    //                                             <th style={{ width: "8%" }}>Taluka</th>
    //                                             <th style={{ width: "8%" }}>GR Amount</th>
    //                                             <th style={{ width: "9%" }}>GR Number</th> */}
    //                                             <th style={{ width: "15%" }}>Work Name</th>
    //                                             <th style={{ width: "9%" }}>Financial Year</th>
    //                                             <th style={{ width: "9%" }}>District</th>
    //                                             <th style={{ width: "9%" }}>Taluka</th>
    //                                             <th style={{ width: "9%" }}>Proposal Work Cost</th>
    //                                             <th style={{ width: "9%" }}>MHUID Number</th>
    //                                             <th style={{ width: "9%" }}>Physical Value in %</th>
    //                                             <th style={{ width: "9%" }}>Limit Allocated Cost</th>
    //                                             <th style={{ width: "9%" }}>Release Amount Till Date</th>
    //                                             <th style={{ width: "9%" }}>Date</th>
    //                                             {/* <th style={{ width: "10%" }}>Financial GR Copy</th> */}
    //                                             {/* <th style={{ width: "10%" }}>Action</th> */}
    //                                             {/* <th style={{ width: "13%" }}>Work Order Copy</th> */}
    //                                             {/* <th>General Manager Approval</th>
    //                         <th>Account Approval</th>
    //                         <th>Admin Approval</th> */}
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         {
    //                                             currentBills?.length === 0 ?
    //                                                 (
    //                                                     <tr>
    //                                                         <td colSpan="12" style={{ textAlign: 'center', padding: '15px 10px', backgroundColor: '#f9f9f9' }}>
    //                                                             No Data Available
    //                                                         </td>
    //                                                     </tr>
    //                                                 )
    //                                                 :
    //                                                 (
    //                                                     currentBills.map((bill, index) => {
    //                                                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                                         return (
    //                                                             <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
                                                                   
    //                                                                 <td style={{ padding: "10px 0px" }}>
    //                                                                     <input
    //                                                                         type="checkbox"
    //                                                                         className='my-auto'
    //                                                                         style={{ height: '1rem', width: '1rem' }}
    //                                                                         checked={selectedBills.includes(bill.ID)}
    //                                                                         onChange={() => handleCheckboxChange(bill.ID)}
    //                                                                     />
    //                                                                 </td>
    //                                                                  <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{indexOfFirstBill + index + 1}</td>
    //                                                                 {/* <td style={{ padding: '8px', cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
    //                                                             onClick={() => setSelectedGR(bill)}
    //                                                         >
    //                                                             View
    //                                                         </td> */}

    //                                                                 {/* <td>{indexOfFirstBill + index + 1}</td> */}
    //                                                                 {/* <td >{bill.ReleaseID}</td> */}
    //                                                                 <td >{bill.ProposalID}</td>
    //                                                                 <td >{bill.FinancialYear}</td>
    //                                                                 <td >{bill.District}</td>
    //                                                                 <td >{bill.Taluka}</td>
    //                                                                 <td >{bill.ProposalCost}</td>
    //                                                                 <td >{bill.MH_UID}</td>
    //                                                                 <td >{bill.physicalValue}</td>
    //                                                                 <td >{bill.LimitAllottedAmount}</td>
    //                                                                 <td >{bill.ReleaseAmountTillDate}</td>
    //                                                                 <td className='px-2' >
    //                                                                     <div style={{ display: "flex", alignItems: "center", gap: "0.4rem", justifyContent: "center" }}>
    //                                                                         <img src="/Time32.png" alt="time" style={{ width: "1rem", height: "1rem" }} />
    //                                                                         <span className='text-primary'>{new Date(bill.Date).toLocaleString()}</span>
    //                                                                     </div>
    //                                                                 </td>
                                                                   
    //                                                                 {/* <td className='py-2'>
                                                                       
    //                                                                     <button
    //                                                                         onClick={() => showSpecificFinancialGRData(bill.ReleaseID)}
    //                                                                         className='m-auto text-center'
    //                                                                         style={{
    //                                                                             width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
    //                                                                             background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
    //                                                                             color: 'white', borderRadius: '8px',
    //                                                                         }}
    //                                                                     > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
    //                                                                         View
    //                                                                     </button>
    //                                                                 </td>   */}
                                                                    
    //                                                                 {/* <td ><p><a href={`${apiurl}/WorkOrderDocsImages/${bill.CopyofWorkOrder}`} target='_blank'>{bill.CopyofWorkOrder}</a></p></td> */}
    //                                                                 {/* <td>{bill.General_Manager_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
    //                             <td>{bill.Account_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
    //                             <td>{bill.Admin_Approval === 'true' ? 'Approved' : 'Not Approved'}</td> */}
    //                                                             </tr>
    //                                                         )
    //                                                     })

    //                                                 )
    //                                         }
    //                                     </tbody>
    //                                 </table>
    //                             </div>

    //                             {/* Pagination Controls */}
    //                             <div className='col-12 mt-3'>

    //                                 <div className="row">

    //                                     <div className='col-6'>
    //                                         <p>Showing {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0} to {Math.min(indexOfLastBill, bills.length)} of {bills.length} entries</p>
    //                                     </div>


    //                                     <div className="col-6 text-end my-auto">
    //                                         {/* First Page Button */}
    //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
    //                                             &laquo;
    //                                         </button>
    //                                         {/* Previous Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage - 1)}
    //                                             disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &lt;
    //                                         </button>

    //                                         <button
    //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                                         </button>
    //                                         {/* Next Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage + 1)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &gt;
    //                                         </button>
    //                                         {/* Last Page Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(totalPages)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &raquo;
    //                                         </button>
    //                                     </div>

    //                                 </div>
    //                                 <div className='col-6 text-start my-auto' style={{ display: 'flex', justifyContent: 'left' }}>
    //                                     <button
    //                                         onClick={() => approveorrejectSelected("Approved")}
    //                                         //    onClick={(e) => { SetGenerateToken(false) }}
    //                                         disabled={selectedBills.length <= 0 ? true : loading}
    //                                         className='ms-0'
    //                                         style={{
    //                                             display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
    //                                             backgroundColor: selectedBills.length <= 0 ? (
    //                                                 'rgba(141, 141, 141, 0.97)'
    //                                             ) : ('#39B54A'), color: 'white', borderRadius: '8px',
    //                                             cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
    //                                         }}
    //                                     ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
    //                                     </button>

    //                                     <button
    //                                         onClick={() => setRejectpanelhide(2)}
    //                                         // onClick={(e) => { SetGenerateRejectToken(false) }}
    //                                         disabled={selectedBills.length <= 0 ? true : loading}
    //                                         style={{
    //                                             display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
    //                                             background: selectedBills.length <= 0 ? (
    //                                                 'rgba(141, 141, 141, 0.97)'
    //                                             ) : ('#C1272D'), color: 'white', borderRadius: '8px',
    //                                             cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
    //                                         }}
    //                                     >
    //                                         <img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
    //                                     </button>

    //                                     {/* <button
    //                                     onClick={() => setRejectpanelhide(3)} disabled={loading}
    //                                     style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right,rgb(158, 127, 59) ,rgb(171, 140, 0) ,rgb(186, 140, 15) ,rgb(213, 156, 0) )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
    //                                 ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
    //                                 </button> */}
    //                                 </div>


    //                             </div>
    //                         </div>
    //                     }
    //                     {
    //                         showSpecific === 1 &&
    //                         <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
    //                             <div className='col-4 text-start mb-3'>
    //                                 <button
    //                                     onClick={() => setShowSpecific(0)}
    //                                     style={{
    //                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px 0px', padding: '8px 15px', fontWeight: "600",
    //                                         background: ('#C1272D'), color: 'white', borderRadius: '8px',
    //                                         cursor: 'pointer'
    //                                     }}
    //                                 >
    //                                     <img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> Close
    //                                 </button>
    //                             </div>
    //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
    //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                     <thead>
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                
    //                                             <th style={{ width: "10%" }}>Financial Release UID</th>
    //                                             <th style={{ width: "10%" }}>Proposal Name</th>
    //                                             <th style={{ width: "10%" }}>Financial Year</th>
    //                                             <th style={{ width: "8%" }}>District</th>
    //                                             <th style={{ width: "8%" }}>Taluka</th>
    //                                             {/* <th style={{ width: "10%" }}>GR Number</th> */}
    //                                             <th style={{ width: "10%" }}>Proposal Cost</th>
    //                                             <th style={{ width: "10%" }}>Limit Allocated Cost</th>
    //                                             <th style={{ width: "10%" }}>Release Amount Till Date</th>
    //                                             <th style={{ width: "10%" }}>Date</th>
    //                                         </tr>

    //                                     </thead>
    //                                     <tbody>
    //                                         {
    //                                             resultFinacialdata.length === 0 ?
    //                                                 (

    //                                                     <tr>
    //                                                         <td colSpan="12" style={{ textAlign: 'center', padding: '15px 10px', backgroundColor: '#f9f9f9' }}>
    //                                                             No data available
    //                                                         </td>
    //                                                     </tr>
    //                                                 ) :
    //                                                 (
    //                                                     resultFinacialdata.map((bill, index) => {
    //                                                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                                         return (
    //                                                             <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
    //                                                                 <td style={{ padding: "10px 0px" }} >{bill.ReleaseID}</td>
    //                                                                 <td >{bill.ProposalID}</td>
    //                                                                 <td >{bill.FinancialYear}</td>
    //                                                                 <td >{bill.District}</td>
    //                                                                 <td >{bill.Taluka}</td>
    //                                                                 {/* <td >{bill.GRID}</td> */}
    //                                                                 <td >{parseFloat(bill.ProposalCost).toFixed(2)}</td>
    //                                                                 <td >{parseFloat(bill.OriginalLimitAllocatedAmount).toFixed(2)}</td>
    //                                                                 <td >{parseFloat(bill.ReleaseAmountTillDate).toFixed(2)}</td>
    //                                                                 <td >{new Date(bill.Date).toLocaleString()}</td>

    //                                                             </tr>
    //                                                         )
    //                                                     }
    //                                                     )

    //                                                 )
    //                                         }
    //                                     </tbody>
    //                                 </table>
    //                             </div>
    //                         </div>
    //                     }
    //                 </div>
    //             </div>




    //         </div>

    //         {
    //             rejectPanelhide === 2 &&

    //             <div className='col-12 RejectPanelContainer'>
    //                 <div className="Rejectpanel">
    //                     <form action="">

    //                         <div className="col-12 elements">
    //                             <div className="row">
    //                                 <div className="col-3">
    //                                     <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
    //                                 </div>
    //                                 <div className="col-8">
    //                                     <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
    //                                     </textarea>
    //                                 </div>
    //                             </div>
    //                         </div>

    //                     </form>
    //                     <div className="col-12 ms-auto my-4">
    //                         <div className="row">
    //                             <div className="col-9 m-auto">
    //                                 <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
    //                                     <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
    //                                     <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //             </div>

    //         }

    //         {/* {
    //             rejectPanelhide === 3 &&

    //             <div className='col-12 RejectPanelContainer'>
    //                 <div className="Rejectpanel">
    //                     <form action="">

    //                         <div className="col-12 elements">
    //                             <div className="row">
    //                                 <div className="col-3">
    //                                     <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
    //                                 </div>
    //                                 <div className="col-8">
    //                                     <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
    //                                     </textarea>
    //                                 </div>
    //                             </div>
    //                         </div>

    //                     </form>
    //                     <div className="col-12 ms-auto my-4">
    //                         <div className="row">
                            
    //                             <div className="col-9 m-auto">
    //                                 <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
    //                                     <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
    //                                     <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //             </div>

    //         } */}

    //         <div className="card">
    //             <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateToken}>
    //                 <div class="card-body" style={{ backgroundColor: "white", width: "50%" }}>
    //                     <h6>Send Message</h6>
    //                     <div class="card form-control" style={{ width: "100%" }}>
    //                         <div class="card-body">
    //                             <h5 class="card-title">Generate Token</h5>
    //                             <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
    //                             <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>

    //                         </div>
    //                     </div>
    //                     <button
    //                         onClick={() => approveorrejectSelected("Approved")} hidden={hide}
    //                         style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
    //                     ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
    //                     </button>
    //                     {/* <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button> */}
    //                     <button className='btn btn-danger' onClick={(x) => { SetGenerateToken(true); SetEtoken("") }}>close</button>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="card">
    //             <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateRejectToken}>
    //                 <div class="card-body" style={{ backgroundColor: "white" }}>
    //                     <h6>Send Message</h6>
    //                     <div class="card form-control" style={{ width: "100%" }}>
    //                         <div class="card-body">
    //                             <h5 class="card-title">Generate Token</h5>
    //                             <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
    //                             <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
    //                         </div>
    //                     </div>
    //                     <div className="form-group my-3">
    //                         <label htmlFor="remark">Remark (Required for Rejection):</label>
    //                         <textarea className='form-control' name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
    //                         </textarea>
    //                     </div>
    //                     <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")} hidden={hide} ><img src={submit} style={{ width: '15px' }} /> Reject</button>
    //                     {/* <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button> */}
    //                     <button className='btn btn-danger' onClick={(x) => { SetGenerateRejectToken(true); SetEtoken("") }}>close</button>
    //                 </div>
    //             </div>
    //         </div>

    //     </>
    // );
  return (

        <>

            <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-12 px-3 m-auto">

                    {loading && (
                        <div
                            style={{
                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                display: 'flex', justifyContent: 'center', alignItems: 'center'
                            }}>
                            <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                            <style>
                                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                            </style>
                        </div>
                    )}

                    <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h5 className='my-auto fw-bold'>
                            <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                            <span className='my-auto'>{t("Limit Allocation Approval")}</span>
                        </h5>

                        {
                            showSpecific === 0 &&
                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>

                        }
                    </div>


                    <div className='col-12' >
                        {
                            showSpecific === 0 &&
                            <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                                     <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead >
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>

                                                <th style={{ width: "4%", textAlign: "center" }}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={selectedBills.length === currentBills.length}
                                                        className='my-auto'
                                                        style={{ height: '1rem', width: '1rem' }}
                                                    />
                                                </th>
                                                {/* <th>View Info</th> */}
                                                <th style={{ width: "9%" }}>{t("Sr. No.")}</th>
                                                {/* <th style={{ width: "9%" }}>Financial Release UID</th> */}
                                                {/* <th style={{ width: "9%" }}>Head Code</th>
                                                <th style={{ width: "9%" }}>Proposal ID</th>
                                                <th style={{ width: "8%" }}>Proposal Year</th>
                                                <th style={{ width: "8%" }}>Zilla Parishad</th>
                                                <th style={{ width: "8%" }}>Taluka</th>
                                                <th style={{ width: "8%" }}>GR Amount</th>
                                                <th style={{ width: "9%" }}>GR Number</th> */}
                                                <th style={{ width: "15%" }}>{t("Work Name")}</th>
                                                 <th style={{ width: "15%" }}>{t("Job ID")}</th>
                                                <th style={{ width: "9%" }}>{t("Financial Year")}</th>
                                                {RoleID !=29 ?"" : <th style={{ width: "16%" }}>{t("Head Code")}</th>}
                                                <th style={{ width: "9%" }}>{t("District")}</th>
                                                <th style={{ width: "9%" }}>{t("Taluka")}</th>
                                                <th style={{ width: "9%" }}>{t("Proposal Work Cost")}</th>
                                                <th style={{ width: "9%" }}>{t("MHUID Number")}</th>
                                                <th style={{ width: "9%" }}>{t("Physical Progress In %")}</th>
                                                <th style={{ width: "9%" }}>{t("Limit Allocated Cost")}</th>
                                                {/* <th style={{ width: "12%" }}>{t("Release Amount Till Date")}</th> */}
                                                <th style={{ width: "9%" }}>{t("Date")}</th>
                                                {/* <th style={{ width: "10%" }}>Financial GR Copy</th> */}
                                                {/* <th style={{ width: "10%" }}>Action</th> */}
                                                {/* <th style={{ width: "13%" }}>Work Order Copy</th> */}
                                                {/* <th>General Manager Approval</th>
                            <th>Account Approval</th>
                            <th>Admin Approval</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentBills?.length === 0 ?
                                                    (
                                                        <tr>
                                                            <td colSpan="13" style={{ textAlign: 'center', padding: '15px 10px', backgroundColor: '#f9f9f9' }}>
                                                                {t("No Data Available")}
                                                            </td>
                                                        </tr>
                                                    )
                                                    :
                                                    (
                                                        currentBills.map((bill, index) => {
                                                            const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                            return (
                                                                <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
                                                                   
                                                                    <td style={{ padding: "10px 0px" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className='my-auto'
                                                                            style={{ height: '1rem', width: '1rem' }}
                                                                            checked={selectedBills.includes(bill.ID)}
                                                                            onChange={() => handleCheckboxChange(bill.ID)}
                                                                        />
                                                                    </td>
                                                                     <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{indexOfFirstBill + index + 1}</td>
                                                                    {/* <td style={{ padding: '8px', cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                                                onClick={() => setSelectedGR(bill)}
                                                            >
                                                                View
                                                            </td> */}

                                                                    {/* <td>{indexOfFirstBill + index + 1}</td> */}
                                                                    {/* <td >{bill.ReleaseID}</td> */}
                                                                    <td >{bill.ProposalID}</td>
                                                                    <td >{bill.JOB_ID}</td>
                                                                    <td >{bill.FinancialYear}</td>
                                                                    {RoleID !=29 ?"" : <td >{bill.HeadCode}</td>}
                                                                    <td >{bill.District}</td>
                                                                    <td >{bill.Taluka}</td>
                                                                    <td >{bill.ProposalCost}</td>
                                                                    <td >{bill.MH_UID}</td>
                                                                    <td >{bill.physicalValue}</td>
                                                                    <td >{bill.LimitAllottedAmount}</td>
                                                                    {/* <td >{bill.ReleaseAmountTillDate}</td> */}
                                                                    <td className='px-2' >
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "0.4rem", justifyContent: "center" }}>
                                                                            <img src="/Time32.png" alt="time" style={{ width: "1rem", height: "1rem" }} />
                                                                            <span className='text-primary'>{new Date(bill.Date).toLocaleString()}</span>
                                                                        </div>
                                                                    </td>
                                                                   
                                                                    {/* <td className='py-2'>
                                                                       
                                                                        <button
                                                                            onClick={() => showSpecificFinancialGRData(bill.ReleaseID)}
                                                                            className='m-auto text-center'
                                                                            style={{
                                                                                width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                                background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                                                color: 'white', borderRadius: '8px',
                                                                            }}
                                                                        > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
                                                                            View
                                                                        </button>
                                                                    </td>   */}
                                                                    
                                                                    {/* <td ><p><a href={`${apiurl}/WorkOrderDocsImages/${bill.CopyofWorkOrder}`} target='_blank'>{bill.CopyofWorkOrder}</a></p></td> */}
                                                                    {/* <td>{bill.General_Manager_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
                                <td>{bill.Account_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
                                <td>{bill.Admin_Approval === 'true' ? 'Approved' : 'Not Approved'}</td> */}
                                                                </tr>
                                                            )
                                                        })

                                                    )
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination Controls */}
                                <div className='col-12 mt-3'>

                                    <div className="row">

                                        <div className='col-6'>
                                            <p>{t("Showing")} {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0} {t("to")} {Math.min(indexOfLastBill, bills.length)} {t("of")} {bills.length} {t("entries")}</p>
                                        </div>


                                        <div className="col-6 text-end my-auto">
                                            {/* First Page Button */}
                                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                                &laquo;
                                            </button>
                                            {/* Previous Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &lt;
                                            </button>

                                            <button
                                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                            </button>
                                            {/* Next Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &gt;
                                            </button>
                                            {/* Last Page Button */}
                                            <button
                                                onClick={() => setCurrentPage(totalPages)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &raquo;
                                            </button>
                                        </div>

                                    </div>
                                    <div className='col-6 text-start my-auto' style={{ display: 'flex', justifyContent: 'left' }}>
                                        <button
                                            onClick={() => approveorrejectSelected("Approved")}
                                            //    onClick={(e) => { SetGenerateToken(false) }}
                                            disabled={selectedBills.length <= 0 ? true : loading}
                                            className='ms-0'
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                backgroundColor: selectedBills.length <= 0 ? (
                                                    'rgba(141, 141, 141, 0.97)'
                                                ) : ('#39B54A'), color: 'white', borderRadius: '8px',
                                                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                            }}
                                        ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? t('Processing...') : t("Approve Selected")}
                                        </button>

                                        <button
                                            onClick={() => setRejectpanelhide(2)}
                                            // onClick={(e) => { SetGenerateRejectToken(false) }}
                                            disabled={selectedBills.length <= 0 ? true : loading}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                background: selectedBills.length <= 0 ? (
                                                    'rgba(141, 141, 141, 0.97)'
                                                ) : ('#C1272D'), color: 'white', borderRadius: '8px',
                                                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? t('Processing...') : t("Reject Selected")}
                                        </button>

                                        {/* <button
                                        onClick={() => setRejectpanelhide(3)} disabled={loading}
                                        style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right,rgb(158, 127, 59) ,rgb(171, 140, 0) ,rgb(186, 140, 15) ,rgb(213, 156, 0) )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                                    ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                                    </button> */}
                                    </div>


                                </div>
                            </div>
                        }
                        {
                            showSpecific === 1 &&
                            <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                                <div className='col-4 text-start mb-3'>
                                    <button
                                        onClick={() => setShowSpecific(0)}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px 0px', padding: '8px 15px', fontWeight: "600",
                                            background: ('#C1272D'), color: 'white', borderRadius: '8px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> Close
                                    </button>
                                </div>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                
                                                <th style={{ width: "10%" }}>{t("Financial Release UID")}</th>
                                                <th style={{ width: "10%" }}>{t("Proposal Name")}</th>
                                                <th style={{ width: "10%" }}>{t("Financial Year")}</th>
                                                <th style={{ width: "8%" }}>{t("District")}</th>
                                                <th style={{ width: "8%" }}>{t("Taluka")}</th>
                                                {/* <th style={{ width: "10%" }}>GR Number</th> */}
                                                <th style={{ width: "10%" }}>{t("Proposal Cost")}</th>
                                                <th style={{ width: "10%" }}>{t("Limit Allocated Cost")}</th>
                                                {/* <th style={{ width: "10%" }}>{t("Release Amount Till Date")}</th> */}
                                                <th style={{ width: "10%" }}>{t("Date")}</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {
                                                resultFinacialdata.length === 0 ?
                                                    (

                                                        <tr>
                                                            <td colSpan="13" style={{ textAlign: 'center', padding: '15px 10px', backgroundColor: '#f9f9f9' }}>
                                                               {t("No data available")}
                                                            </td>
                                                        </tr>
                                                    ) :
                                                    (
                                                        resultFinacialdata.map((bill, index) => {
                                                            const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                            return (
                                                                <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
                                                                    <td style={{ padding: "10px 0px" }} >{bill.ReleaseID}</td>
                                                                    <td >{bill.ProposalID}</td>
                                                                    <td >{bill.FinancialYear}</td>
                                                                    <td >{bill.District}</td>
                                                                    <td >{bill.Taluka}</td>
                                                                    {/* <td >{bill.GRID}</td> */}
                                                                    <td >{parseFloat(bill.ProposalCost).toFixed(2)}</td>
                                                                    <td >{parseFloat(bill.OriginalLimitAllocatedAmount).toFixed(2)}</td>
                                                                    {/* <td >{parseFloat(bill.ReleaseAmountTillDate).toFixed(2)}</td> */}
                                                                    <td >{new Date(bill.Date).toLocaleString()}</td>

                                                                </tr>
                                                            )
                                                        }
                                                        )

                                                    )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>




            </div>

            {
                rejectPanelhide === 2 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>{t("Remark")} <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder={t("Enter Remark")} value={remark} onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> {t("Reject")}</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />{t("Cancel")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            }

            {/* {
                rejectPanelhide === 3 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                            
                                <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            } */}

            <div className="card">
                <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateToken}>
                    <div class="card-body" style={{ backgroundColor: "white", width: "50%" }}>
                        <h6>{t("Send Message")}</h6>
                        <div class="card form-control" style={{ width: "100%" }}>
                            <div class="card-body">
                                <h5 class="card-title">{t("Generate Token")}</h5>
                                <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
                                <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>{t("Generate Token")}</button>

                            </div>
                        </div>
                        <button
                            onClick={() => approveorrejectSelected("Approved")} hidden={hide}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                        ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
                        </button>
                        {/* <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button> */}
                        <button className='btn btn-danger' onClick={(x) => { SetGenerateToken(true); SetEtoken("") }}>{t("close")}</button>
                    </div>
                </div>
            </div>

            <div className="card">
                <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateRejectToken}>
                    <div class="card-body" style={{ backgroundColor: "white" }}>
                        <h6>{t("Send Message")}</h6>
                        <div class="card form-control" style={{ width: "100%" }}>
                            <div class="card-body">
                                <h5 class="card-title">{t("Generate Token")}</h5>
                                <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
                                <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>{t("Generate Token")}</button>
                            </div>
                        </div>
                        <div className="form-group my-3">
                            <label htmlFor="remark">{t("Remark (Required for Rejection):")}</label>
                            <textarea className='form-control' name="" id="" placeholder={t("Enter Remark")} value ={remark} onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}>
                            </textarea>
                        </div>
                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")} hidden={hide} ><img src={submit} style={{ width: '15px' }} /> {t("Reject")}</button>
                        {/* <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button> */}
                        <button className='btn btn-danger' onClick={(x) => { SetGenerateRejectToken(true); SetEtoken("") }}>{t("close")}</button>
                    </div>
                </div>
            </div>

        </>
    );
};




export default FinancialGR;